var storedOptions = JSON.parse(localStorage.getItem("bds-a11y"));

if (null === storedOptions || 0 === storedOptions.length) {
	storedOptions = {};
}

document.addEventListener("DOMContentLoaded", function() {
	var buttons = document.querySelectorAll("button.a11y__button");
	if (0 !== buttons.length) {
		buttons.forEach(function(button) {
			button.addEventListener("click", function(event) {
				var key = event.target.value;
				if (key in storedOptions) {
					storedOptions[key] = storedOptions[key] ? 0 : 1;
				} else {
					storedOptions[key] = 1;
				}
				this.classList.toggle("active");
				document.activeElement.blur();
				document.body.classList.toggle("a11y__" + key);
				localStorage.setItem("bds-a11y", JSON.stringify(storedOptions));
			});
		});
	}
	for (var [key, val] of Object.entries(storedOptions)) {
		if (1 === val) {
			var buttons = document.querySelectorAll("button.a11y__button[value=" + key + "]");
			if (0 !== buttons.length) {
				buttons.forEach(function(button) {
					button.classList.toggle("active");
				});
			}
			document.body.classList.toggle("a11y__" + key);
		}
	}
	var toggles = document.querySelectorAll("button.a11y__toggle");
	if (0 !== toggles.length) {
		toggles.forEach(function(toggle) {
			toggle.addEventListener("click", function(event) {
				event.preventDefault();
				var toolbars = document.querySelectorAll(".a11y");
				if (0 !== toolbars.length) {
					toolbars.forEach(function(toolbar) {
						toolbar.classList.toggle("active");
						document.activeElement.blur();
					});
				}
			});
		});
	}
}, false);
